import React, { useRef, useCallback } from "react"
import PropTypes from "prop-types"
import style from "./Phone.module.css"
import matchesPhoneImg from "../../assets/images/screenshots/matches/matches-cyan.png"
import buddiesPhoneImg from "../../assets/images/screenshots/buddies/buddies-cyan.png"
import IntersectionObserverWrapper from "../ioWrapper/IOWrapper"

const Phone = ({ index, customClass }) => {
  const images = ["", matchesPhoneImg, buddiesPhoneImg]

  const phoneRef = useRef()
  const isVisible = useRef(false)

  const handleIntersection = useCallback(entries => {
    if (isVisible.current) return
    const entry = entries[0]
    const intersectionRatio = entry.intersectionRatio
    if (intersectionRatio > 0.5) {
      phoneRef.current.style.transform = `translateY(0%)`
      phoneRef.current.style.opacity = 1
      isVisible.current = true
    } else {
      phoneRef.current.style.transform = `translateY(30%)`
      phoneRef.current.style.opacity = 0
    }
  }, [])

  return (
    <IntersectionObserverWrapper
      thresholdSteps={10}
      callback={handleIntersection}
    >
      <img
        ref={phoneRef}
        className={[style.phone, customClass].join(" ")}
        src={images[index]}
        alt="phone"
      />
    </IntersectionObserverWrapper>
  )
}

Phone.propTypes = {
  index: PropTypes.number.isRequired,
  customClass: PropTypes.string,
}

Phone.defaultProps = {
  index: 0,
}

export default Phone
